(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ImageStorageDetailController', ImageStorageDetailController);

    ImageStorageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'ImageStorage'];

    function ImageStorageDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, ImageStorage) {
        var vm = this;

        vm.imageStorage = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:imageStorageUpdate', function(event, result) {
            vm.imageStorage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
